import { Button } from "@bluframe/blublocks"
import styled from "styled-components"

export const Wrapper = styled(Button)`
  font-weight: 400;
`
